import React from 'react';
import PropTypes from 'prop-types';

import {ValuesDashRedChip} from '@utils/decorators';

export const getFieldsList = (event) => {
    return [
        {
            name: 'Cancelled',
            value: <ValuesDashRedChip options={{value: event.sr_event.match.is_cancelled, valueHighlight: 'Yes'}} />,
        },
        {
            name: 'Postponed',
            value: <ValuesDashRedChip options={{value: event.sr_event.match.is_postponed, valueHighlight: 'Yes'}} />,
        },
        {
            name: 'Walkover',
            value: <ValuesDashRedChip options={{value: event.sr_event.match.is_walkover, valueHighlight: 'Yes'}} />,
        },
        {
            name: 'Abandoned',
            value: <ValuesDashRedChip options={{value: event.sr_event.match.is_abandoned, valueHighlight: 'Yes'}} />,
        },
    ];
};

getFieldsList.propTypes = {
    event: PropTypes.shape({
        sr_event: PropTypes.shape({
            match: PropTypes.shape({
                is_cancelled: PropTypes.bool,
                is_postponed: PropTypes.bool,
                is_walkover: PropTypes.bool,
            }),
        }),
    }).isRequired,
};

getFieldsList.defaultProps = {
    event: {
        sr_event: {
            match: {
                is_cancelled: null,
                is_postponed: null,
                is_walkover: null,
            },
        },
    },
};
